import { render, staticRenderFns } from "./SettingsVerifyPhoneNumber.vue?vue&type=template&id=21c90b3d&scoped=true&"
import script from "./SettingsVerifyPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./SettingsVerifyPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./SettingsVerifyPhoneNumber.vue?vue&type=style&index=0&id=21c90b3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c90b3d",
  null
  
)

export default component.exports